<form [formGroup]="profileForm" (ngSubmit)="submitChanges()">
  <div class="mb-24">
    <div class="form-group">
      <div class="img-container">
        <img
          *ngIf="profileInfo?.pictureUrl"
          [src]="profileInfo?.pictureUrl"
          alt=""
          class="img-fluid"
          id="new_pic"
        />
        <app-base-name-avatar
          *ngIf="!profileInfo?.pictureUrl"
          [name]="profileInfo?.name"
          [size]="'large'"
        ></app-base-name-avatar>
      </div>
      <input
        class="d-none"
        (change)="handleImgUpload($event)"
        accept="image/*"
        type="file"
        id="profile-img"
      />
      <label for="profile-img" class="text__brand pointer f-14 fw-600 lh-20"
        >Change picture</label
      >
    </div>
  </div>
  <div class="form-group mb-24">
    <label for="firstName" class="auth-label">First name</label>
    <input
      type="text"
      formControlName="firstName"
      id="firstName"
      class="auth-input"
    />
  </div>

  <div class="form-group mb-24">
    <label for="lastName" class="auth-label">Last name</label>
    <input
      type="text"
      formControlName="lastName"
      id="lastName"
      class="auth-input"
    />
  </div>

  <div class="form-group mb-24">
    <label for="email" class="auth-label">Email address</label>
    <input type="email" formControlName="email" id="email" class="auth-input" />
  </div>

  <app-base-button
    label="Save changes"
    [disabled]="profileForm.invalid"
    [colorClasses]="'custom__btn custom__btn-brand custom-btn-lg btn fw-600'"
  ></app-base-button>
</form>
